<template>
    <div
        class="salepage-product__select tw-grid tw-grid-cols-1 tw-gap-2 md:tw-grid-cols-2 md:tw-gap-4"
    >
        <div
            class="tw-p-2 tw-bg-white tw-grid tw-grid-cols-5 tw-gap-x-4 tw-gap-y-2 tw-rounded tw-justify-between modern-item"
            @click="openProductDetail(item)"
            v-for="(item, index) in salePageProduct"
            :key="index"
        >
            <div class="tw-col-span-1">
                <div class="image-with-qty">
                    <div 
                        v-if="queueQuantity(item) > 0"
                        class="qty tw-flex tw-justify-center tw-align-middle"
                        :style="`border: 2px solid ${salePage.button_color}; background-color: #ffffff`"
                    >
                        <div class="tw-self-end tw-font-black">
                            {{ queueQuantity(item)}}
                        </div>
                    </div>
                    <img
                        :src="item.image_thumb_url"
                        class="tw-w-full tw-rounded mr-2"
                        :alt="item.name"
                    />
                </div>
            </div>
            <div class="tw-col-span-4">
                <div class="tw-font-bold tw-text-xl tw-flex tw-justify-between">
                    <div class="max-w-2/3">{{ item.name }}</div>
                    <div>
                        <button
                            v-if="parseFloat(item.stock_balance) > 0"
                            class="btn btn-sm btn-salepage"
                            :style="`background-color: ${salePage.button_color}; color: ${salePage.button_text};`"
                            v-on:click.stop="addToCart(item.id)"
                        >
                            <i class="fa fa-plus"></i> เพิ่มใส่ตะกร้า
                        </button>
                        <button
                            v-if="parseFloat(item.stock_balance) <= 0"
                            class="btn btn-light btn-sm btn-block"
                            disabled
                        >
                            สินค้าหมด
                        </button>
                    </div>
                </div>
                <div>
                    <span
                        v-if="
                            parseFloat(item.price) < parseFloat(item.price_full)
                        "
                        class="tw-line-through tw-text-gray-400"
                        >{{ currency ? currency.symbol : '' }} 
                        {{
                            Number(item.price_full).toLocaleString(undefined, {
                                minimumFractionDigits: 2
                            })
                        }}</span
                    >
                    <span
                        v-if="
                            parseFloat(item.price) < parseFloat(item.price_full)
                        "
                        class="tw-text-red-500"
                        >{{ currency ? currency.symbol : '' }} 
                        {{
                            Number(item.price).toLocaleString(undefined, {
                                minimumFractionDigits: 2
                            })
                        }}</span
                    >
                    <span
                        v-if="
                            parseFloat(item.price) >=
                                parseFloat(item.price_full)
                        "
                        class="tw-text-black"
                        >{{ currency ? currency.symbol : '' }} 
                        {{
                            Number(item.price).toLocaleString(undefined, {
                                minimumFractionDigits: 2
                            })
                        }}</span
                    >
                </div>
                <div
                    class="tw-text-gray-400 tw-text-xs"
                >
                    {{ item.description }}
                </div>
            </div>
        </div>

        <!-- Detailed Product -->
        <salepage-body-detail-product-component
            :productDetailOpen="productDetailOpen"
            :product="productDetail"
            :salePage="salePage"
            :currency="currency"
            :queueQuantity="queueQuantity(productDetail)"
            @closeProductDetail="closeProductDetail"
            @addToCart="addToCart"
        >
        </salepage-body-detail-product-component>
    </div>
</template>
<script>

export default {
    props: ["salePageProduct", "salePage", "currency", "queue", "isbgDark"],
    data() {
        return {
            productDetailOpen: false,
            productDetail: null,
        }
    },
    methods: {
        addToCart(productId, quantity = 1) {
            this.$emit("addToCart", productId, quantity);
        },
        queueQuantity(product) {
            if (product){
                let queueProduct = this.queue.find(item => item.product_id == product.id);
                return queueProduct ? queueProduct.quantity : 0;
            }
        },
        openProductDetail(product) {
            this.productDetailOpen = true;
            this.productDetail = product;
        },
        closeProductDetail() {
            this.productDetailOpen = false;
            this.productDetail = null;
        },
    },
};
</script>
<style scoped lang="scss">
.text-ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.max-w-2\/3 {
    max-width: 66.666667%;
}
.btn-salepage:hover {
    box-shadow: inset 0px 0px 0px 2000px rgba(0, 0, 0, 0.3);
    transition: all 0.25s ease;
}

.btn-salepage:focus {
    box-shadow: inset 0px 0px 0px 2000px rgba(0, 0, 0, 0.3);
    box-shadow: 0 0 0 0.2rem rgba(1, 1, 1, 0.25);
    transition: all 0.25s ease;
}
.qty {
    position: absolute;
    width: 30px;
    height: 30px;
    border-radius: 9999px;
    margin: -10px -10px;
    z-index: 10;
}
    
</style>
